require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-helps-raise-over-usd-341-000-for-pack-the-pantries.json") })
        }
      }, "path---es-articles-financial-center-helps-raise-over-usd-341-000-for-pack-the-pantries");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-helps-raise-over-usd-341-000-for-pack-the-pantries!./.cache/json/es-articles-financial-center-helps-raise-over-usd-341-000-for-pack-the-pantries.json
// module id = 2107
// module chunks = 231608221292675